/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1EfforttypesQueryResponse } from '../../types/GetV1Efforttypes.ts'

export const getV1EfforttypesQueryKey = () => [{ url: '/v1/EffortTypes' }] as const

export type GetV1EfforttypesQueryKey = ReturnType<typeof getV1EfforttypesQueryKey>

/**
 * {@link /v1/EffortTypes}
 */
export async function getV1Efforttypes(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<GetV1EfforttypesQueryResponse, ResponseErrorConfig<Error>, unknown>({
        method: 'GET',
        url: `/v1/EffortTypes`,
        ...requestConfig,
    })
    return res
}

export function getV1EfforttypesQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1EfforttypesQueryKey()
    return queryOptions<
        ResponseConfig<GetV1EfforttypesQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1EfforttypesQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Efforttypes(config)
        },
    })
}

/**
 * {@link /v1/EffortTypes}
 */
export function useGetV1Efforttypes<
    TData = ResponseConfig<GetV1EfforttypesQueryResponse>,
    TQueryData = ResponseConfig<GetV1EfforttypesQueryResponse>,
    TQueryKey extends QueryKey = GetV1EfforttypesQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1EfforttypesQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1EfforttypesQueryKey()

    const query = useQuery(
        {
            ...getV1EfforttypesQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
